import { useParams, Link } from "react-router-dom";
import products from "../data/products";
import { useState } from "react";
import { useCart } from "../context/CartContext";
import Toast from "../components/Toast";

export default function ProductDetail() {
    const { id } = useParams();
    const product = products.find(p => p.id === Number(id));
    const { addToCart } = useCart();

    // ✅ Hooks always at top (Fix for ESLint error)
    const [qty, setQty] = useState(1);
    const [showToast, setShowToast] = useState(false);
    const [selectedVariant, setSelectedVariant] = useState(
        product ? product.variants[0] : null
    );

    if (!product) {
        return <p className="text-center py-20">Product नहीं मिला</p>;
    }

    // ✅ Related Products
    const relatedProducts = products.filter(
        (p) => p.id !== product.id
    );

    const handleAddToCart = () => {
        for (let i = 0; i < qty; i++) {
            addToCart(product, selectedVariant);
        }

        setShowToast(true);
        setTimeout(() => setShowToast(false), 2000);
    };

    return (
        <div className="relative">

            <Toast show={showToast} message="Product added successfully" />

            <div className="max-w-7xl mx-auto px-6 py-24">
                <div className="grid md:grid-cols-2 gap-12">

                    {/* IMAGE */}
                    <div className="bg-white rounded-2xl shadow-xl p-6">
                        <img
                            src={selectedVariant.image}
                            alt={product.name}
                            className="w-full h-[420px] object-contain"
                        />
                    </div>

                    {/* INFO */}
                    <div className="bg-white rounded-2xl shadow-xl p-8">

                        <span className="inline-block mb-4 bg-green-600 text-white px-4 py-1 rounded-full text-sm font-semibold">
                            COD Available
                        </span>

                        <h1 className="text-4xl font-extrabold text-[#7a0c18]">
                            {product.name}
                        </h1>

                        <p className="mt-3 text-gray-700">
                            {product.desc}
                        </p>

                        <p className="mt-6 text-3xl font-bold text-green-700">
                            ₹ {selectedVariant.price}
                            <span className="text-lg text-gray-600 ml-2">
                                ({selectedVariant.weight})
                            </span>
                        </p>

                        {/* ✅ WEIGHT SELECTOR ADD KIYA */}
                        {product.variants.length > 1 && (
                            <div className="mt-6">
                                <p className="font-semibold mb-3">Pack Size:</p>

                                <div className="flex gap-3 flex-wrap">
                                    {product.variants.map((variant, index) => (
                                        <button
                                            key={index}
                                            onClick={() => setSelectedVariant(variant)}
                                            className={`px-5 py-2 rounded-full border font-semibold transition
                                            ${selectedVariant.weight === variant.weight
                                                    ? "bg-[#7a0c18] text-white border-[#7a0c18]"
                                                    : "bg-white text-[#7a0c18] border-[#7a0c18]"
                                                }`}
                                        >
                                            {variant.weight}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* QUANTITY SELECTOR */}
                        <div className="flex items-center gap-4 mt-6">
                            <span className="font-semibold">Quantity:</span>

                            <button
                                onClick={() => qty > 1 && setQty(qty - 1)}
                                className="w-10 h-10 rounded-full border text-xl"
                            >
                                −
                            </button>

                            <span className="text-lg font-bold">{qty}</span>

                            <button
                                onClick={() => setQty(qty + 1)}
                                className="w-10 h-10 rounded-full border text-xl"
                            >
                                +
                            </button>
                        </div>

                        {/* ACTION BUTTONS */}
                        <div className="mt-8 flex flex-col gap-4">

                            <button
                                onClick={handleAddToCart}
                                className="bg-[#ffcc00] text-black py-4 rounded-xl text-lg font-semibold"
                            >
                                🛒 Add to Cart
                            </button>

                            <Link
                                to="/cart"
                                className="bg-[#7a0c18] text-white py-4 rounded-xl text-lg font-semibold text-center"
                            >
                                👀 View Cart
                            </Link>

                            <Link
                                to="/products"
                                className="border border-[#7a0c18] text-[#7a0c18] py-4 rounded-xl text-lg font-semibold text-center"
                            >
                                ➕ Add More Products
                            </Link>

                            <a
                                href={`https://wa.me/919752772880?text=${encodeURIComponent(
                                    `मुझे ${product.name} चाहिए (${selectedVariant.weight}) x ${qty}`
                                )}`}
                                target="_blank"
                                rel="noreferrer"
                                className="bg-[#25D366] text-white py-4 rounded-xl text-lg font-semibold text-center"
                            >
                                WhatsApp पर ऑर्डर करें
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* ✅ RELATED PRODUCTS UPDATED */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 pb-20 mt-16">

                {/* Heading */}
                <div className="text-center mb-12">
                    <h2 className="inline-block bg-white px-6 py-3 rounded-xl shadow-md
                       text-2xl sm:text-3xl font-bold text-[#7a0c18]">
                        Other Products
                    </h2>
                </div>

                {/* Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
                    {relatedProducts.map((item) => (
                        <Link
                            key={item.id}
                            to={`/products/${item.id}`}
                            className="bg-white rounded-2xl shadow-lg 
                       hover:shadow-xl transition duration-300 overflow-hidden"
                        >
                            {/* IMAGE CONTAINER */}
                            <div className="w-full h-52 flex items-center justify-center bg-white">
                                <img
                                    src={item.variants[0].image}
                                    alt={item.name}
                                    className="max-h-44 w-auto object-contain"
                                />
                            </div>

                            {/* CONTENT */}
                            <div className="px-4 py-4 text-center">
                                <h3 className="font-bold text-[#7a0c18] text-lg">
                                    {item.name}
                                </h3>

                                <p className="text-green-700 font-semibold mt-1">
                                    ₹ {item.variants[0].price}
                                </p>
                            </div>
                        </Link>
                    ))}
                </div>

            </div>


        </div>
    );
}
